module.exports = __webpack_public_path__ + "static/media/get-an-offer-sunnybank.25e1981d.png";